<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="考前备案" name="bfEdit">
        <before-edit/>
      </el-tab-pane>
      <el-tab-pane label="考后备案" name="afEdit">
        <after-edit :activeName="activeName"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BeforeEdit from './components/beforeEdit'
import AfterEdit from './components/afterEdit'

let activeName = 'bfEdit'

export default {
  name: 'examination-record',
  components: { BeforeEdit, AfterEdit },
  props: [],
  data () {
    return {
      activeName: 'bfEdit'
    }
  },
  async created () {
    this.activeName = activeName
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  beforeRouteEnter (to, from, next) {
    // ...
    const  { path, fullPath } = from
    if ('/workflow/examination-record-detail' === path) {
      const name = fullPath.substring(fullPath.indexOf('name=') + 5)
      activeName = name
      console.log(name,'name');
    }
    next()
  },
  computed: {},
  watch: {},
  methods: {
    // handleClick (tab, event) {

    // }
  }
}
</script>
